import gql from 'graphql-tag';
import { List, Map } from 'immutable';
import find from 'lodash/find';
import result from 'lodash/result';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { compose, graphql } from 'react-apollo';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { ProjectActions } from '../actions/project';
import { projectsLoadedAllSelector, projectsLoadingAllSelector } from '../reducers/projects';
import { currentUserSelector, getUserModeByProjectId } from '../reducers/users';
// import Loading from '../components/Loading';
import '../styles/ProjectCardsContainer.css';
import Loading from './Loading';
import ProjectCard from './cards/ProjectCard';
import ProjectCopyLoadingCard from './cards/ProjectCopyLoadingCard';
import NoElements from './states/NoElements';


const queryPlans = gql`
  query plans {
    plans {
      id
      name
    }
  }
`;

const queryAccounts = gql`
  query myAccounts {
    myAccounts {
      id
      name
    }
  }
`;

const suspendProject = gql`
  mutation suspendProject($projectId: ID!) {
    suspendProject(projectId: $projectId) {
      id
      is_suspended
    }
  }
`;

const unsuspendProject = gql`
  mutation unsuspendProject($projectId: ID!) {
    unsuspendProject(projectId: $projectId) {
      id
      is_suspended
    }
  }
`;

const withMutation = compose(
  graphql(queryPlans, {
    name: 'plans',
    options: () => ({
      fetchPolicy: 'network-only',
    }),
  }),
  graphql(queryAccounts, {
    name: 'accounts',
    options: () => ({
      fetchPolicy: 'network-only',
    }),
  }),
  graphql(suspendProject, {
    props: ({ mutate }) => ({
      suspendProject: values => {
        return mutate({
          variables: values,
        });
      },
    }),
  }),
  graphql(unsuspendProject, {
    props: ({ mutate }) => ({
      unsuspendProject: values => {
        return mutate({
          variables: values,
        });
      },
    }),
  }),
);

@withMutation
export class ProjectCards extends PureComponent {
  state = {
    isSubmitting: false,
  };

  static propTypes = {
    accountId: PropTypes.string,
    projects: PropTypes.oneOfType([
      PropTypes.instanceOf(List),
      PropTypes.instanceOf(Map),
    ]).isRequired,
    users: PropTypes.instanceOf(Map).isRequired,
    copying: PropTypes.bool,
    currentUser: PropTypes.instanceOf(Map),
    projectsUsers: PropTypes.instanceOf(Map),
    deleteRedirect: PropTypes.bool,
    dispatch: PropTypes.func,
  };

  suspendProject = async projectId => {
    const { suspendProject, dispatch } = this.props;
    this.setState({ isSubmitting: true });
    await suspendProject({ projectId });
    dispatch(ProjectActions.suspendProject(projectId));
    // await dispatch({
    //   type: actions.createProject.success,
    //   args: [{ account_id: accountId }],
    //   result: normalize(resp.data.createProject, projectSchema),
    // });
    this.setState({ isSubmitting: false });
  };

  unsuspendProject = async projectId => {
    const { unsuspendProject, dispatch } = this.props;
    this.setState({ isSubmitting: true });
    await unsuspendProject({ projectId });
    dispatch(ProjectActions.unsuspendProject(projectId));
    this.setState({ isSubmitting: false });
  };

  isUnassignedButAccAdmin = (projectId, currentUserId) => {
    const { accountId, users, currentUser } = this.props;
    if (!accountId) return false;
    const isAccountAdmin =
      users.getIn([currentUserId, 'roles', 'account', accountId]) <= 2;
    const isAssignedToProject = currentUser.getIn([
      'roles',
      'project',
      projectId,
    ]);
    // const isAssignedToProject = projectsUsers.find(
    //   (v, k) => k === projectId && v.has(currentUserId),
    // );

    return isAccountAdmin && !isAssignedToProject;
  };

  projects() {
    const {
      dispatch,
      projects,
      currentUser,
      users,
      copying,
      deleteRedirect,
      accounts,
      plans,
    } = this.props;
    // console.log('project cards container', projects);

    // const projectsArray = [];
    const sortedProjects = [];

    if (!projects || !projects.size) return;

    projects.forEach(a => {
      sortedProjects.push(a);
    });

    const assigned = [];
    const unassigned = [];

    sortedProjects.sort((a, b) => b.get('id') - a.get('id')).forEach((v, k) => {
      // console.log(
      //   'unassigned acc admin?',
      //   v.get('id'),
      //   this.isUnassignedButAccAdmin(v.get('id'), currentUser.get('id')),
      // );
      if (v) {
        const projectUserId = v.getIn(['created_by_id']);
        const user = users.get(projectUserId, null);
        const userMode = getUserModeByProjectId(currentUser, v.get('id'));
        const isUnassignedButAccAdmin = this.isUnassignedButAccAdmin(
          v.get('id'),
          currentUser.get('id'),
        );
        const isProjectSuspended = v.get('is_suspended') === true;
        const accountName = result(find(accounts.myAccounts, a => a.id === v.get('account_id')), 'name');
        const planName = result(find(plans.plans, p => p.id === v.get('plan_id')), 'name');
        const isAccountAdmin = users.getIn([currentUser.get('id'), 'roles', 'account', v.get('account_id')]) <= 2;
        // console.log('??????', v.get('id'), v.get('name'), isAccountAdmin);
        // console.log('assigned?', v.get('id'), isUnassignedButAccAdmin);
        const card = (
          <ProjectCard
            project={v}
            currentUser={currentUser}
            user={user}
            key={k}
            unassignedButAccAdmin={isUnassignedButAccAdmin}
            copying={copying}
            dispatch={dispatch}
            userMode={userMode}
            deleteRedirect={deleteRedirect}
            isSuspended={isProjectSuspended}
            isAccountAdmin={isAccountAdmin}
            suspendProject={this.suspendProject}
            unsuspendProject={this.unsuspendProject}
            accountName={accountName}
            planName={planName}
          />
        );
        if (isUnassignedButAccAdmin) {
          unassigned.push(card);
        } else {
          assigned.push(card);
        }
      }
    });

    return assigned.concat(unassigned);
  }

  render() {
    const { projects, projectsLoadingAll, projectsLoadedAll } = this.props;
    const projectsList = this.projects();
    const copyingCard = this.props.copying ? <ProjectCopyLoadingCard /> : null;

    if (projects.size === 0 && projectsLoadedAll) {
      return (
        <NoElements options={{ ignoreBold: true }} missingType='organization' />
      )
    } else if (projectsLoadingAll) {
      return <Loading loadingMessage="Loading projects..." />;
    }

    return (
      <div className="row col-xs projects-list">
        {copyingCard}
        {projectsList}
      </div>
    );
  }
}

const projectsUsersSelector = state => state.projectsUsers.get('projectsUsers');

const projectsSelector = (state, props) => {
  if (props.projects) return props.projects;
  // const projectIds = state.projectsUsers
  //   .get('projectsUsers')
  //   .keySeq()
  //   .toArray();
  const currentUserProjects = state.projectsUsers
    .get('projectsUsers')
    .map((v, k) => state.projects.getIn(['projects', k], Map()));
  return currentUserProjects;
};

// const projectsSelector = (state, props) =>
//   return props.projects || state.projects.get('projects');

const usersSelector = state => state.users.get('users');
const projectCopyingSelector = state => state.projects.get('isCopying');

const ProjectCardsSelector = createSelector(
  [
    projectsSelector,
    currentUserSelector,
    usersSelector,
    projectCopyingSelector,
    projectsUsersSelector,
    projectsLoadingAllSelector,
    projectsLoadedAllSelector,
  ],
  (projects, currentUser, users, copying, projectsUsers, projectsLoadingAll, projectsLoadedAll) => ({
    projects,
    currentUser,
    users,
    copying,
    projectsUsers,
    projectsLoadingAll,
    projectsLoadedAll,
  }),
);

@connect(ProjectCardsSelector)
export default class ProjectCardsContainer extends PureComponent {
  static propTypes = {
    projects: PropTypes.oneOfType([
      PropTypes.instanceOf(List),
      PropTypes.instanceOf(Map),
    ]).isRequired,
    currentUser: PropTypes.instanceOf(Map),
    users: PropTypes.instanceOf(Map),
    dispatch: PropTypes.func,
    deleteRedirect: PropTypes.bool,
  };

  componentWillMount() {
    const { projects } = this.props;

    if (projects.size === 0) {
      // dispatch(ProjectActions.getProjects(accountId));
    }
  }

  render() {
    return <ProjectCards {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/ProjectCardsContainer.js